import job from '@/store/modules/pto/project/pto/job'
import planning from '@/store/modules/pto/project/pto/planning'

import supply from '@/store/modules/pto/project/pto/supply'
import supplyRequest from '@/store/modules/pto/project/pto/supplyRequest'
import nomenclature from '@/store/modules/pto/project/pto/nomenclature'

import kmd from '@/store/modules/pto/project/pto/kmd'
import cmk from '@/store/modules/pto/project/pto/cmk'
import cmo from '@/store/modules/pto/project/pto/cmo'
import pvh from '@/store/modules/pto/project/pto/pvh'
import bru from '@/store/modules/pto/project/pto/bru'
import ppr from '@/store/modules/pto/project/pto/ppr'

export default {
  namespaced: true,
  modules: {
    job,
    planning,
    supply,
    supplyRequest,
    nomenclature,
    kmd,
    cmk,
    cmo,
    pvh,
    bru,
    ppr
  }
}
